import React, { useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { Layout, Menu, Avatar, Dropdown, Row } from "antd";
import { useHistory } from "react-router";
import Cookies from "js-cookie";
import styled from "styled-components";
import {
  CopyOutlined,
  UserOutlined,
  ClusterOutlined,
  ClockCircleOutlined,
  GroupOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  TeamOutlined
} from "@ant-design/icons";

const { Header, Content, Sider } = Layout;

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  .ant-card-bordered {
    min-height: 80vh;
  }
  .site-layout .site-layout-background {
    background: #fff;
  }
  .trigger {
    padding: 0 24px;
    font-size: 24px;
    line-height: 64px;
    cursor: pointer;
    transition: color 0.3s;
  }
  .trigger:hover {
    color: #1890ff;
  }
  .ant-dropdown-trigger {
    margin-right: 20px;
  }
`;

const Logo = styled.img`
  height: auto;
  width: 160px;
  margin-top: 20px;
  display: block;
  margin-left: 12px;
`;

const ProtectedRoute = ({ component: Component, ...restOfProps }) => {
  const role = Cookies.get("role");
  const isAuthenticated = role ? true : false;
  const [collapsed, setCollapsed] = useState(false);
  const handleMenuClick = () => {
    Cookies.remove("role");
    window.location.reload();
  };
  const importAll = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace("./", "")] = r(item);
    });
    return images;
  };

  const images = importAll(
    require.context("../../images", false, /\.(png|jpe?g|svg)$/)
  );

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1">Logout</Menu.Item>
    </Menu>
  );
  const history = useHistory();
  return (
    <Route
      {...restOfProps}
      render={(props) =>
        isAuthenticated ? (
          <StyledLayout>
            <Sider
              trigger={null}
              collapsible
              breakpoint="lg"
              collapsed={collapsed}
            >
              <div className="logo">
                {!collapsed && <Logo src={images["logo1.png"]} />}
              </div>
              <Menu
                theme="dark"
                mode="inline"
                style={{ marginTop: "30px" }}
              // defaultSelectedKeys={[{ code }]}
              >
                <Menu.Item
                  key="1"
                  icon={<ClockCircleOutlined />}
                  onClick={() => history.push("/events")}
                >
                  Events
                </Menu.Item>
                <Menu.Item
                  key="2"
                  icon={<GroupOutlined />}
                  onClick={() => history.push("/groups")}
                >
                  Groups
                </Menu.Item>
                <Menu.Item
                  key="4"
                  icon={<CopyOutlined />}
                  onClick={() => history.push("/contents")}
                >
                  Contents
                </Menu.Item>
                <Menu.Item
                  key="5"
                  icon={<TeamOutlined />}
                  onClick={() => history.push("/eventPlayers")}
                >
                  Event Players
                </Menu.Item>
                {role && role === "SuperAdmin" && (
                  <Menu.Item
                    key="6"
                    icon={<UserOutlined />}
                    onClick={() => history.push("/userManagement")}
                  >
                    User Management
                  </Menu.Item>
                )}
              </Menu>
            </Sider>
            <Layout className="site-layout">
              <Header className="site-layout-background" style={{ padding: 0 }}>
                <Row type="flex" justify="space-between">
                  {React.createElement(
                    collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                    {
                      className: "trigger",
                      onClick: () => setCollapsed((prev) => !prev),
                    }
                  )}
                  <Dropdown
                    overlay={menu}
                    trigger={["click"]}
                    placement="bottom"
                  >
                    <div onClick={(e) => e.preventDefault()}>
                      <Avatar size="large" icon={<UserOutlined />} />
                    </div>
                  </Dropdown>
                </Row>
              </Header>
              <Content style={{ margin: "24px 16px 0" }}>
                <div
                  className="site-layout-background"
                  style={{ padding: 24, height: "auto", width: "auto" }}
                >
                  <>
                    {role &&
                      role.toLowerCase() === "admin" &&
                      Component && Component.name === "UserManagement" ? (
                      <Redirect to={"/events"} />
                    ) : (
                      <Component {...props} />
                    )}
                  </>
                </div>
              </Content>
            </Layout>
          </StyledLayout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default ProtectedRoute;
